import React, { useRef } from "react"
import { useNavigate } from "react-router-dom"
import { useGlobalContext } from "../../Context/GlobalContext"
import { motion } from "framer-motion"
import "./card.css"

function Card({ cardProp }) {
  const { title, subtitle, imageUrl, yellow, orange } = cardProp
  const navigate = useNavigate()
  const { setCoords, setDimentions } = useGlobalContext()
  const cardRef = useRef(null)

  const handleClick = (e) => {
    e.preventDefault()
    const titleId = title.replace(" ", "-").replace("& ", "").toLowerCase()

    setCoords({
      x: cardRef.current.getBoundingClientRect().left,
      y: cardRef.current.getBoundingClientRect().top,
    })
    setDimentions({
      w: cardRef.current.getBoundingClientRect().width,
      h: cardRef.current.getBoundingClientRect().height,
    })

    navigate(`/destination/${titleId}`, { state: { destination: cardProp } })
  }

  return (
    <motion.article
      ref={cardRef}
      data-scroll
      data-scroll-speed="1"
      className="card"
      onClick={handleClick}
    >
      <img data-scroll data-scroll-speed="-1" src={imageUrl} alt="" />
      <motion.div
        exit={{ opacity: 0 }}
        transition={{ duration: 0.5, ease: "circOut" }}
        className="card-content"
      >
        <motion.h1
          className={`serif-2 ${
            orange ? "clr-accent" : yellow ? "clr-yellow" : ""
          }`}
        >
          {title}
        </motion.h1>
        <p>{subtitle}</p>
      </motion.div>
    </motion.article>
  )
}

export default Card
